import * as sessionStorage from "../../util/SessionStorage"

const searchQueryKey = "SEARCH_QUERY"

export const saveSearchQuery = (searchText: string): void =>
    sessionStorage.setItem(searchQueryKey, searchText)

export const getSearchQuery = (): string => {
    const data = sessionStorage.getItem(searchQueryKey)
    return data ?? ""
}

export const clearSearchQuery = (): void => {
    sessionStorage.removeItem(searchQueryKey)
}
